const initialState = {
  loading: false,
  data: [],
  errors: [],
  count: 0,
};

const pushNewPhase = (payload, state) => {
  const stateData = [...state.data];
  stateData.push(payload);
  return stateData;
};

const removeRelatedPhase = (relatedPhaseId, state) =>
  state.data.filter(relatedPhase =>
    relatedPhase.id !== relatedPhaseId);

const related = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case 'PHASE_RESOURCE_REQUEST':
      return initialState;
    case 'REQUEST_RELATED_PHASES_REQUEST':
      return {
        ...state,
        loading: true,
        errors: [],
      };
    case 'REQUEST_RELATED_PHASES_SUCCESS':
      return {
        ...state,
        loading: false,
        data: payload.relatedPhases,
        count: payload.relatedPhases.length,
      };
    case 'CREATE_RELATED_PHASE_SUCCESS': {
      const data = pushNewPhase(payload.relatedPhase, state);
      return {
        ...state,
        loading: false,
        data,
        count: data.length,
      };
    }
    case 'REMOVE_RELATED_PHASE_SUCCESS': {
      const data = removeRelatedPhase(payload.relatedPhaseId, state);
      return {
        ...state,
        loading: false,
        data,
        count: data.length,
      };
    }
    case 'PHASE_RESOURCE_SUCCESS':
    case 'PHASE_RESOURCE_CREATE_SUCCESS':
    case 'PHASE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        count: meta.related_count,
      };
    case 'REQUEST_RELATED_PHASES_FAILURE':
    case 'CREATE_RELATED_PHASE_FAILURE':
    case 'REMOVE_RELATED_PHASE_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'CREATE_RELATED_PHASE_REQUEST':
    default:
      return state;
  }
};

export default related;



// WEBPACK FOOTER //
// ./client/app/reducers/related_phases.js